export enum CategoriaEmpresa {
	PRESTADOR_SERVICO = "P", 
	COMERCIAL="C",
	INDUSTRIAS= "I",
    OUTRO = "O"
}